import { defineMessages } from "react-intl";

export const messages = defineMessages({
  generalTitle: {
    id: '8QU9i1',
    defaultMessage: "General information",
    description: "series detail, card title",
  },
  name: {
    id: 'eRfskQ',
    defaultMessage: "Name",
    description: "series detail field",
  },
  slug: {
    id: 'XflCyt',
    defaultMessage: "Slug",
    description: "series detail field",
  },
  slugHelp: {
    id: 'eOb0/t',
    defaultMessage: "The series' own path on the storefront. Left blank, it is made from the name.",
    description: "series detail field help",
  },
  tagline: {
    id: 'r8xosX',
    defaultMessage: "Tagline",
    description: "series detail field",
  },
  brand: {
    id: 'wCDYUX',
    defaultMessage: "Brand",
    description: "series detail field",
  },
  brandHelp: {
    id: 'orwRgB',
    defaultMessage: "Every product in a series comes from one brand.",
    description: "series detail field help",
  },
  description: {
    id: 'szAjSb',
    defaultMessage: "Description",
    description: "series detail field",
  },
  extendedDescription: {
    id: 'RzqG+d',
    defaultMessage: "Extended description",
    description: "series detail field",
  },
  extendedDescriptionHelp: {
    id: 'aJm30O',
    defaultMessage: "Shown below the products on the series page.",
    description: "series detail field help",
  },
  image: {
    id: 'OSMAJm',
    defaultMessage: "Image URL",
    description: "series detail field",
  },
  imageHelp: {
    id: 'kZSp89',
    defaultMessage: "The series image, by URL.",
    description: "series detail field help",
  },
  missMessage: {
    id: 'q3/za9',
    defaultMessage: "No-match message",
    description: "series detail field",
  },
  missMessageHelp: {
    id: 'yL2cE6',
    defaultMessage: "What a shopper is told when nothing in the series fits.",
    description: "series detail field help",
  },
  productsTitle: {
    id: '72SSQO',
    defaultMessage: "Products",
    description: "series detail, card title",
  },
  products: {
    id: 'isPbWJ',
    defaultMessage: "Products in this series",
    description: "series detail field",
  },
  productsHelp: {
    id: 'IOatzs',
    defaultMessage: "In the order the storefront shows them. A published series needs at least two published products.",
    description: "series detail field help",
  },
  published: {
    id: '60z/o4',
    defaultMessage: "Show this series on the storefront",
    description: "series detail field",
  },
  availabilityTitle: {
    id: 'EeqUF1',
    defaultMessage: "Availability",
    description: "series detail, sidebar card title",
  },
  seoTitle: {
    id: 'Lm17+z',
    defaultMessage: "Search engine preview",
    description: "series detail, sidebar card title",
  },
  seoTitleField: {
    id: 'Sl1n18',
    defaultMessage: "Search engine title",
    description: "series detail field",
  },
  seoDescriptionField: {
    id: 'ogpls6',
    defaultMessage: "Search engine description",
    description: "series detail field",
  },
  summaryTitle: {
    id: 'zO+2aK',
    defaultMessage: "Series summary",
    description: "series detail, sidebar card title",
  },
  memberCount: {
    id: 'RYsLZF',
    defaultMessage: "{count, plural, one {# product} other {# products}}",
    description: "series detail, sidebar member count",
  },
  sortOrder: {
    id: 'LyzWeJ',
    defaultMessage: "Position",
    description: "series detail field",
  },
  sortOrderHelp: {
    id: 'gVpH0W',
    defaultMessage: "Lowest first, where the storefront lists series.",
    description: "series detail field help",
  },
  axesTitle: {
    id: '41xzIg',
    defaultMessage: "Questions shoppers answer",
    description: "series detail, card title",
  },
  axesSubtitle: {
    id: 'WMBrEQ',
    defaultMessage:
      "Tick a product attribute to ask about it. The order you tick them in is the order the shopper is asked.",
    description: "series detail, card subtitle",
  },
  axesOrder: {
    id: 'h8wXH5',
    defaultMessage: "Asked in this order: {order}",
    description: "series detail, ask order summary",
  },
  axesEmpty: {
    id: 'tuUO0W',
    defaultMessage: "This store has no product attributes to ask about yet",
    description: "series detail, empty state",
  },
  axisUnknown: {
    id: 'SvxOdb',
    defaultMessage: "no attribute with this slug in this store",
    description: "series detail, orphaned axis slug",
  },
  partitioningAxis: {
    id: 'WEVWc4',
    defaultMessage: "Variations split by",
    description: "series detail field",
  },
  partitioningAxisHelp: {
    id: '/62fC4',
    defaultMessage: "One of the questions above. Every published product needs an answer to it.",
    description: "series detail field help",
  },
});
